import { AxiosResponse } from 'axios';
import axios from '../../../helpers/AxiosConfig';
import {
  DeleteCatalogsResponse,
  GetCatalogsParams,
  GetCatalogsResponse,
  GetSourceFilterOptionsResponse,
  GetSourceFilesResponse,
  AddCatalogParams,
  AddCatalogMutationParams,
  AddCatalogRequest,
  AddCatalogApiResponse,
  GetCatalogFileDataParams,
  GetCatalogFileDataResponse,
  GetCatalogColumnParams,
  GetCatalogColumnResponse,
  EditCatalogParams,
  GetCatalogUploadJobStatusResponse,
} from './catalog.types';

export const getCatalogs = async (
  params: GetCatalogsParams,
): Promise<AxiosResponse<GetCatalogsResponse>> => {
  return await axios.get<GetCatalogsResponse>('catalogs', {
    params,
  });
};

export const getCatalogFilterOptions = async () => {
  return await axios.get<GetSourceFilterOptionsResponse>('catalogs/filter-options');
};

export const archiveCatalog = async (ids: number[]) => {
  return axios.delete<DeleteCatalogsResponse>(`/catalogs/delete`, {
    params: { ids },
  });
};

export const fetchSourceFiles = async (ids: number[], getOriginal = false) => {
  return axios.get<GetSourceFilesResponse>(`/catalog/getSourceFiles`, {
    params: { ids: JSON.stringify(ids), getOriginal: getOriginal },
  });
};

export const addCatalog = async (
  request: AddCatalogMutationParams,
): Promise<AxiosResponse<AddCatalogApiResponse>> => {
  const isAddCatalogRequest =
    typeof request === 'object' && request !== null && 'params' in request;
  const payload: AddCatalogParams = isAddCatalogRequest
    ? (request as AddCatalogRequest).params
    : (request as AddCatalogParams);
  const onUploadProgress = isAddCatalogRequest
    ? (request as AddCatalogRequest).onUploadProgress
    : undefined;
  const asyncProcessing = isAddCatalogRequest
    ? (request as AddCatalogRequest).asyncProcessing
    : undefined;

  return await axios.post<AddCatalogApiResponse>('catalog/addToCatalog', payload, {
    params: asyncProcessing ? { async: true } : undefined,
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress,
  });
};

export const getCatalogUploadJobStatus = async (jobId: string) => {
  return await axios.get<GetCatalogUploadJobStatusResponse>(`/catalog/upload-jobs/${jobId}`);
};

export const getCatalogData = async (
  params: GetCatalogFileDataParams,
): Promise<AxiosResponse<GetCatalogFileDataResponse>> => {
  return await axios.get<GetCatalogFileDataResponse>('/catalog/getCatalogFileData', {
    params,
  });
};

export const getCatalogColumn = async (
  params: GetCatalogColumnParams,
): Promise<AxiosResponse<GetCatalogColumnResponse>> => {
  return await axios.get<GetCatalogColumnResponse>('/catalogs/searchField', {
    params,
  });
};

export const updateCatalog = async ({ id, data }: EditCatalogParams): Promise<AxiosResponse> => {
  return axios.put(`/catalogs/${id}/edit`, data);
};

export const getFile = async ({ id }: { id: number | undefined }) => {
  return axios.get(`/catalog/download/${id}`, { responseType: 'blob' });
};
